import React from "react";
import Footer from "../components/landing/Footer";
import TopNavBar from "../components/nav/TopNavBar";

const Support: React.FC = () => {
  return (
    <>
      <TopNavBar />
      <div className="w-full relative bg-white overflow-hidden flex flex-col items-start justify-start leading-[normal] tracking-[normal] p-6">
        <h1 className="text-2xl font-bold mb-4">Support</h1>
        <p className="mb-4">
          For support, please contact{" "}
          <a
            href="mailto:support@youwo.ai"
            className="text-blue-600 hover:underline"
          >
            support@youwo.ai
          </a>
        </p>
      </div>
      <Footer />
    </>
  );
};

export default Support;
